import { isValidPhoneNumber } from "react-phone-number-input";
import { z } from "zod";
import { GenderSchema } from "../user/update-user-schema";

export const acExpoInterlocutorBaseSchema = z.object({
  interlocutorGender: GenderSchema.optional(),
  interlocutorFirstName: z.string().optional(),
  interlocutorLastName: z.string().optional(),
  interlocutorEmail: z.string().email("Email invalide").optional().or(z.literal("")),
  interlocutorPhone: z
    .string()
    .refine((phone) => !phone || isValidPhoneNumber(phone, "FR"), {
      message: "Téléphone invalide",
    })
    .optional(),
  adoptedSolution: z.string().optional(),
  text: z.string().optional(),
});

export const acExpoInterlocutorSchema = acExpoInterlocutorBaseSchema.superRefine(
  (data, ctx) => {
    const hasInterlocutorName = data?.interlocutorFirstName || data?.interlocutorLastName;
    if (hasInterlocutorName) {
      if (!data?.interlocutorEmail) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "L'email de l'interlocuteur est requis",
          path: ["interlocutorEmail"],
        });
      }
      if (!data?.interlocutorPhone) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Le téléphone de l'interlocuteur est requis",
          path: ["interlocutorPhone"],
        });
      }
    }
  }
);

export type AcExpoInterlocutorForm = z.infer<typeof acExpoInterlocutorSchema>;
